<template>
  <div class="v-user-create-update-form">
    <div class="modal-backdrop">
      <div class="modal">

        <header class="modal-header">
          <slot name="header">
            <h5 v-if="this.userId && this.$router.currentRoute.path === '/dealers'">
              Редактировать информацию о дилере
            </h5>
            <h5 v-else-if="this.$router.currentRoute.path === '/dealers'">
              Добавить нового дилера
            </h5>
            <h5 v-else-if="this.userId && this.$router.currentRoute.path === '/subscribers'">
              Редактировать информацию о подписчике
            </h5>
            <h5 v-else-if="this.$router.currentRoute.path === '/subscribers'">
              Добавить нового подписчика
            </h5>
            <h5 v-else-if="this.userId && this.$router.currentRoute.path === '/employees'">
              Редактировать информацию о сотруднике
            </h5>
            <h5 v-else-if="this.$router.currentRoute.path === '/employees'">
              Добавить нового сотрудника
            </h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>

        <section class="modal-body">
          <slot name="body">
            <div v-if="this.userId && this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <form  v-else class="form"
                   @submit.prevent="createUpdateUser" autocomplete="nope">

              <div class="px-3">
                <h5>Общая информация</h5>
              </div>
              <div class="row mx-3">
                <div class="col-lg-12">
                  <div class="form-group">
                    <vue-simple-suggest
                      ref="vueSimpleSuggest" v-model="inputs.full_name"
                      value-attribute="id" display-attribute="title"
                      mode="input" :list="getFIOList" @suggestion-click="onFIOClick"
                      @request-start="onFIORequestStart" @request-done="onFIORequestDone"
                      :controls="{
                        selectionUp: [38],
                        selectionDown: [40],
                        select: [13],
                        showList: [40],
                        hideList: [27],
                        autocomplete: [32, 13]
                      }">
                      <input class="form-control" placeholder="Поиск Ф.И.О." type="search">
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        {{ suggestion.title }}
                      </div>
                      <div class="misc-item" slot="misc-item-below" v-if="FIOLoading">
                        <span>Loading...</span>
                      </div>
                    </vue-simple-suggest>
                  </div>
                </div>
              </div>
              <div class="row mx-3">
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           autocomplete="nope" required id="last_name"
                           v-model="inputs.last_name"/>
                    <label for="last_name">Фамилия</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           autocomplete="nope" required id="first_name"
                           v-model="inputs.first_name"/>
                    <label for="first_name">Имя</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           autocomplete="nope" required id="middle_name"
                           v-model="inputs.middle_name"/>
                    <label for="middle_name">Отчество</label>
                  </div>
                </div>
              </div>
              <div class="row mx-3">
                <div class="col-lg-4">
                  <datepicker v-model="inputs.birthday" placeholder="Дата рождения"
                    :language="ru" @input="inputs.birthday = fixDate($event)"
                    input-class="form-control" wrapper-class="form-group" id="birthday"
                    :disabled-dates="state.disabledDates" />
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input v-mask="['+7 (###) ###-##-##', '+7 (###) ###-##-##']"
                           class="form-control" required id="contact_phone"
                           v-model="inputs.contact_phone" autocomplete="nope"
                           @focusin="InputFocusIn('contact_phone')"
                           @focusout="InputFocusOut('contact_phone')"/>
                    <label for="contact_phone">Контактный тел.</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control" type="email" autocomplete="none"
                           id="email" v-model="inputs.email"
                           @focusin="InputFocusIn('email')"
                           @focusout="InputFocusOut('email')"/>
                    <label for="email">Email</label>
                  </div>
                </div>
              </div>

              <div class="px-3 pt-3">
                <h5>Паспортные данные</h5>
              </div>
              <div class="row mx-3">
                <div class="col-lg-4">
                  <datepicker v-model="inputs.passport.date_of_issue" placeholder="Дата выдачи"
                    :language="ru" @input="inputs.passport.date_of_issue = fixDate($event)"
                    input-class="form-control" id="issue" wrapper-class="form-group" />
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input v-mask="['## ##', '## ##']" class="form-control"
                           type="text" autocomplete="none"
                           required id="series" v-model="inputs.passport.series"
                           @focusin="InputFocusIn('series')"
                           @focusout="InputFocusOut('series')"/>
                    <label for="series">Серия</label>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control" v-mask="['######', '######']"
                           type="text" autocomplete="none" required id="number"
                           v-model="inputs.passport.number"
                           @focusin="InputFocusIn('number')"
                           @focusout="InputFocusOut('number')"/>
                    <label for="number">Номер</label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <vue-simple-suggest
                      ref="vueSimpleSuggest" v-model="inputs.passport.passport_title"
                      value-attribute="id" display-attribute="title" mode="input"
                      :list="getFMSList" @suggestion-click="onFMSClick"
                      @request-start="onFMSRequestStart" @request-done="onFMSRequestDone"
                      :controls="{
                        selectionUp: [38],
                        selectionDown: [40],
                        select: [13],
                        showList: [40],
                        hideList: [27],
                        autocomplete: [32, 13]
                      }">
                      <input class="form-control"
                             placeholder="Поиск по коду или названию" type="search">
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        {{ suggestion.title }}
                      </div>
                      <div class="misc-item" slot="misc-item-below" v-if="FMSLoading">
                        <span>Loading...</span>
                      </div>
                    </vue-simple-suggest>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           required id="unit_code" autocomplete="nope"
                           v-model="inputs.passport.unit_code"/>
                    <label for="issued_by">Код</label>
                  </div>
                </div>
                <div class="col-lg-10">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           required id="issued_by" autocomplete="nope"
                           v-model="inputs.passport.issued_by"/>
                    <label for="issued_by">Кем выдан</label>
                  </div>
                </div>
              </div>

              <div class="px-3 pt-3">
                <h5>Адрес регистрации</h5>
              </div>

              <div class="row mx-3">
                <div class="col-lg-12">
                  <div class="form-group">
                    <vue-simple-suggest ref="vueSimpleSuggest"
                                        v-model="inputs.passport.address_title"
                                        value-attribute="id"
                                        display-attribute="title"
                                        mode="input"
                                        :list="getAddressList"
                                        @suggestion-click="onAddressClick"
                                        @request-start="onAddressRequestStart"
                                        @request-done="onAddressRequestDone"
                                        :controls="{
                                          selectionUp: [38],
                                          selectionDown: [40],
                                          select: [13],
                                          showList: [40],
                                          hideList: [27],
                                          autocomplete: [32, 13]
                                        }">
                      <input class="form-control" placeholder="Поиск адреса" type="search">
                      <div slot="suggestion-item" slot-scope="{ suggestion }">
                        {{ suggestion.title }}
                      </div>
                      <div class="misc-item" slot="misc-item-below" v-if="AddressLoading">
                        <span>Loading...</span>
                      </div>
                    </vue-simple-suggest>
                  </div>
                </div>
              </div>
              <div class="row mx-3 pt-3">
                <div class="col-lg-4">
                  <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                    <input class="form-control bg-light" type="text" onkeypress="return false;"
                           required id="city" autocomplete="nope"
                           v-model="inputs.passport.city"/>
                    <label for="city">Населенный пункт</label>
                  </div>
                </div>
                <div class="col-lg-4">
                <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                  <input class="form-control bg-light" type="text" onkeypress="return false;"
                         required id="street" autocomplete="nope"
                         v-model="inputs.passport.street"/>
                  <label for="street">Улица</label>
                </div>
              </div>
                <div class="col-lg-2">
                <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                  <input class="form-control bg-light" type="text" onkeypress="return false;"
                         required id="home" autocomplete="nope"
                         v-model="inputs.passport.home"/>
                  <label for="home">Дом</label>
                </div>
              </div>
                <div class="col-lg-2">
                <div class="form-group" v-bind:class="[ this.userId  ? 'filled' : '' ]">
                  <input class="form-control bg-light" type="text" onkeypress="return false;"
                         id="apartment" autocomplete="nope"
                         v-model="inputs.passport.apartment"/>
                  <label for="apartment">Кв.</label>
                </div>
              </div>
              </div>

              <div v-if="!this.userId" class="m-3 text-center">
                <div class="form-check">
                  <input
                    type="checkbox" class="form-check-input"
                    id="checkbox" v-model="inputs.send_sms">
                  <label class="pl-3 form-check-label" for="checkbox">
                    Отправить SMS с паролем
                  </label>
                </div>
              </div>

              <div class="row px-3">
                <div class="col">
                  <button v-if="this.userId"
                           type="submit" class="btn btn-primary">Обновить данные</button>
                  <button
                    v-else type="submit" class="btn btn-primary">Добавить</button>
                </div>
              </div>
            </form>
          </slot>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ru } from 'vuejs-datepicker/dist/locale';
import * as moment from 'moment/moment';
import VueSimpleSuggest from 'vue-simple-suggest';
import address from '../../api/search';

const state = {
  disabledDates: {
    to: new Date(1900, 0, 0), // Disable all dates up to specific date
    from: new Date(2007, 0, 0), // Disable all dates after specific date
  },
};

export default {
  name: 'v-user-create-update-form',
  components: { VueSimpleSuggest },
  props: ['userId'],
  data() {
    return {
      state,
      ru,
      inputs: {
        full_name: '',
        last_name: '',
        first_name: '',
        middle_name: '',
        birthday: '',
        contact_phone: '',
        email: '',
        role: this.getRole(),
        send_sms: true,
        passport: {
          passport_title: '',
          series: '',
          number: '',
          date_of_issue: '',
          unit_code: '',
          issued_by: '',
          city: '',
          street: '',
          home: '',
          apartment: '',
          address_title: '',
        },
      },
      FIOLoading: false,
      AddressLoading: false,
      FMSLoading: false,
      loading: true,
    };
  },
  computed: {
    ...mapState('user', ['userDetail', 'error']),
  },
  methods: {
    ...mapActions('user', ['getUser', 'createUser', 'updateUserData']),
    close() {
      this.$emit('close');
    },
    onAddressRequestStart() {
      this.AddressLoading = true;
    },
    onAddressRequestDone() {
      this.AddressLoading = false;
    },
    onAddressClick(suggest) {
      if (suggest.city) {
        this.inputs.passport.city = suggest.city;
        this.InputFocusIn('city');
      }
      if (suggest.street) {
        this.inputs.passport.street = suggest.street;
        this.InputFocusIn('street');
      }
      if (suggest.home) {
        this.inputs.passport.home = suggest.home;
        this.InputFocusIn('home');
      }
      if (suggest.apartment) {
        this.inputs.passport.apartment = suggest.apartment;
        this.InputFocusIn('apartment');
      }
    },
    getAddressList() {
      return address.getAddressValue(this.inputs.passport.address_title)
        .then((response) => response.data.result);
    },
    onFIORequestStart() {
      this.FIOLoading = true;
    },
    onFIORequestDone() {
      this.FIOLoading = false;
    },
    onFIOClick(suggest) {
      if (suggest.first_name) {
        this.inputs.first_name = suggest.first_name;
        this.InputFocusIn('first_name');
      }
      if (suggest.last_name) {
        this.inputs.last_name = suggest.last_name;
        this.InputFocusIn('last_name');
      }
      if (suggest.middle_name) {
        this.inputs.middle_name = suggest.middle_name;
        this.InputFocusIn('middle_name');
      }
    },
    getFIOList() {
      return address.getFIOValue(this.inputs.full_name)
        .then((response) => response.data.result);
    },
    onFMSRequestStart() {
      this.FMSLoading = true;
    },
    onFMSRequestDone() {
      this.FMSLoading = false;
    },
    onFMSClick(suggest) {
      if (suggest.title) {
        this.inputs.passport.issued_by = suggest.title;
        this.InputFocusIn('issued_by');
      }
      if (suggest.code) {
        this.inputs.passport.unit_code = suggest.code;
        this.InputFocusIn('unit_code');
      }
    },
    getFMSList() {
      return address.getFMSUnitValue(this.inputs.passport.passport_title)
        .then((response) => response.data.result);
    },
    getRole() {
      if (this.$router.currentRoute.path === '/employees') {
        return 'employee';
      }
      if (this.$router.currentRoute.path === '/dealers') {
        return 'dealer';
      }
      return 'subscriber';
    },
    fixDate(event) {
      return moment(event).format('YYYY-MM-DD');
    },
    createUpdateUser() {
      if (this.userId) {
        delete this.inputs.username;
        delete this.inputs.contact_phone;
        const newData = { userId: this.userDetail.id, data: this.inputs };
        this.updateUserData(newData)
          .then(() => {
            if (!this.error) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Пользователь успешно обновлен!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      } else if (!this.inputs.birthday) {
        document.getElementById('birthday').classList.add('bg-danger');
      } else if (!this.inputs.passport.date_of_issue) {
        document.getElementById('issue').classList.add('bg-danger');
      } else {
        this.createUser(this.inputs)
          .then(() => {
            if (!this.error) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Пользователь успешно добавлен!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      }
    },
  },
  mounted() {
    if (this.userId) {
      this.getUser(this.userId)
        .then(() => {
          this.inputs = this.userDetail;
          if (!this.userDetail.passport) {
            this.inputs.passport = {
              passport_title: '',
              series: '',
              number: '',
              date_of_issue: '',
              unit_code: '',
              issued_by: '',
              city: '',
              street: '',
              home: '',
              apartment: '',
              address_title: '',
            };
          }
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
};
</script>
